import { render, staticRenderFns } from "./SvgPreviewWithDownload.vue?vue&type=template&id=04631e18&scoped=true&"
import script from "./SvgPreviewWithDownload.vue?vue&type=script&lang=js&"
export * from "./SvgPreviewWithDownload.vue?vue&type=script&lang=js&"
import style0 from "./SvgPreviewWithDownload.vue?vue&type=style&index=0&id=04631e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04631e18",
  null
  
)

export default component.exports